export type ElementType = 'common' | 'svg' | 'media' | 'layer' | 'unknown';

/**
 * 元素类型判断 (我的空间的元素、以及品牌库的logo都是这一套)
 * 这个类型是结构类型, 一种数据结构对应一个elementType
 * ext是存储到服务端的值, 由前端自定义结构存储
 * ext类型判断: ext.elementType: 'common' | 'layer' | 'svg' | 'media' (有历史遗留问题, common、layer、svg、media早期的时候没有elementType属性)
 * 从ext结构解析出元素类型及源文件url:
 * 0. unknown: 不知道啥玩意, 应该不存在这种情况, 大概率是脏数据或者未考虑到的兼容问题
 * 1. common (普通图片 如jpg/png到我的空间、上传水印、品牌库上传普通图片的logo): 无ext, 源文件直接拿存储给后端的src
 * 2. layer (图层 如从编辑器画布添加到我的空间): ext存的是图层结构, 这里存在兼容性问题, 旧数据没有准守服务端图层存储规范, 存的是clientLayer; 源文件直接拿ext.data.url ?? ext.url
 * 3. svg (svg图层信息 如我的空间上传svg、品牌库上传svg的logo): 存的是svgInfo, 源文件得拿ext.image
 * 4. media (媒体信息 如上传gif): 源文件直接拿存储给后端的src
 * 5. 类型待补充...
 */
export const getElementTypeAndExtObj = (
    ext: string | undefined | null,
): {
    elementType: ElementType;
    extObj: Record<any, any>;
} => {
    let elementType: ElementType;
    let extObj: Record<any, any> = {};
    try {
        extObj = JSON.parse(ext || '{}');
        elementType = extObj.elementType;
        delete extObj.elementType;

        if (!elementType) {
            // 兼容代码
            const getElementTypeByStructure = () => {
                if (!ext || ext === '') {
                    elementType = 'common';
                } else if (extObj.info) {
                    elementType = 'svg';
                } else if (extObj.isMediaLayer) {
                    elementType = 'media';
                } else if (extObj.layerType) {
                    elementType = 'layer';
                } else {
                    elementType = 'unknown';
                }
                return elementType;
            };
            elementType = getElementTypeByStructure();
        }
    } catch {
        elementType = 'unknown';
    }

    return { elementType, extObj };
};
